export enum VersionChange {
    Minor = 'minor',
    Major = 'major',
    Patch = 'patch',
}
